































































import { defineComponent } from '@vue/composition-api'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Noordkasteel',

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()

    return {
      state
    }
  }
})
